// Hand-plucked runs have no spaces in them — the player's own pauses are the
// punctuation. We take the median gap between plucks and treat anything about
// twice that long as a word break, clamped so a fast run isn't chopped up by
// small hesitations and a slow one still breaks somewhere sensible.
export const MIN_BREAK_MS = 420;
export const MAX_BREAK_MS = 1800;

export function breakThresholdFor(log) {
  if (!log || log.length < 3) return MAX_BREAK_MS;
  const gaps = [];
  for (let i = 1; i < log.length; i += 1) gaps.push(log[i].t - log[i - 1].t);
  const sorted = [...gaps].sort((a, b) => a - b);
  const median = sorted[Math.floor(sorted.length / 2)] || 0;
  return Math.min(MAX_BREAK_MS, Math.max(MIN_BREAK_MS, median * 2));
}

/** Groups a pluck log (each entry { letter, t }) into words. */
export function splitPlucksIntoWords(log) {
  if (!log || log.length === 0) return [];
  const threshold = breakThresholdFor(log);
  const words = [[log[0]]];
  for (let i = 1; i < log.length; i += 1) {
    if (log[i].t - log[i - 1].t >= threshold) words.push([log[i]]);
    else words[words.length - 1].push(log[i]);
  }
  return words;
}

/** The same run as Hebrew word strings, ready to save or replay. */
export function pluckWordStrings(log) {
  return splitPlucksIntoWords(log).map((w) => w.map((p) => p.letter).join(""));
}
